<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div>
      <vx-card>
        <vs-table pagination max-items="10" search :data="menus">

          <template slot="thead">
            <vs-th sort-key="sequence" class="w-1/10">{{ $t("sections.system.dataForm.sequence") }}</vs-th>
            <vs-th sort-key="icon" class="w-1/10">{{ $t("sections.system.dataForm.icon") }}</vs-th>
            <vs-th sort-key="name" class="w-1/5">{{ $t("sections.system.dataForm.name") }}</vs-th>
            <vs-th sort-key="route" class="w-1/5">{{ $t("sections.system.dataForm.route") }}</vs-th>
            <vs-th sort-key="status" class="w-1/5">{{ $t("sections.system.dataForm.status") }}</vs-th>
            <vs-th sort-key="subMenus" class="w-1/5">{{ $t("sections.system.dataForm.subMenus") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td :data="tr.sequence">
                {{ tr.sequence }}
              </vs-td>
              <vs-td :data="tr.icon">
                <feather-icon class="'w-3 h-3'" :icon="tr.icon" />
              </vs-td>
              <vs-td :data="$t(tr.i18n)">
                {{ $t(tr.i18n) }}
              </vs-td>
              <vs-td :data="tr.url">
                {{ tr.url }}
              </vs-td>
              <vs-td :data="tr.status">
                <vs-chip :color="getStatusColor(tr.status)" class="product-order-status">{{ tr.status }}</vs-chip>
              </vs-td>
              <vs-td :data="tr.submenu">
                <router-link :to="{ name: 'system-menu-submenu', params: {id: tr.id} }"  >
                  <vs-button color="primary" icon-pack="feather" size="small">{{ ( tr.submenu ? tr.submenu.length : '0' )+" รายการ" }}</vs-button>
                </router-link>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const {mapActions: mapSystemActions, mapState: mapSystemFields} = createNamespacedHelpers('System')
export default {
  computed: {
    ...mapSystemFields(['menus', 'status'])
  },
  async created () {
    await this.getMenus()
    this.pms ('SystemMenu', 'visible', 'r')
  },
  methods: {
    ...mapSystemActions(['getMenus']),
  }
}
</script>
